/**
 * @generated SignedSource<<eca2435b7bc55915a6c66d9804022335>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OwnerSettingsRendererQuery$variables = {
  name: string;
  platform: string;
};
export type OwnerSettingsRendererQuery$data = {
  readonly ownerInfoByName: {
    readonly " $fragmentSpreads": FragmentRefs<"AppBreadcrumbs_info" | "OwnerSettings_info">;
  } | null;
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"AppBreadcrumbs_viewer">;
  } | null;
};
export type OwnerSettingsRendererQuery = {
  response: OwnerSettingsRendererQuery$data;
  variables: OwnerSettingsRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "platform"
},
v2 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "platform",
    "variableName": "platform"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platform",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ownerUid",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 50
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OwnerSettingsRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "OwnerInfo",
        "kind": "LinkedField",
        "name": "ownerInfoByName",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OwnerSettings_info"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppBreadcrumbs_info"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppBreadcrumbs_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OwnerSettingsRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "OwnerInfo",
        "kind": "LinkedField",
        "name": "ownerInfoByName",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uid",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerPermission",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OwnerInfoDescription",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OwnerInfoDescriptionAction",
                "kind": "LinkedField",
                "name": "actions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "link",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "balanceInCredits",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingSettings",
            "kind": "LinkedField",
            "name": "billingSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabled",
                "storageKey": null
              },
              (v3/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingCreditsLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingEmailAddress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceTemplate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "OwnerTransactionsConnection",
            "kind": "LinkedField",
            "name": "transactions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OwnerTransactionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OwnerTransaction",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "taskId",
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "creditsAmount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Task",
                        "kind": "LinkedField",
                        "name": "task",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "creationTimestamp",
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scheduledTimestamp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "executingTimestamp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "durationInSeconds",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Repository",
                        "kind": "LinkedField",
                        "name": "repository",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "owner",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "transactions(last:50)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MonthlyComputeUsage",
            "kind": "LinkedField",
            "name": "monthlyComputeUsage",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "date",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ComputeUsage",
                "kind": "LinkedField",
                "name": "usageDetails",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "instancePlatform",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "instanceArchitecture",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cpuSeconds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "balanceInMicroCredits",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ApiAccessToken",
            "kind": "LinkedField",
            "name": "apiToken",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maskedToken",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PersistentWorkerPool",
            "kind": "LinkedField",
            "name": "persistentWorkerPools",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledForPublic",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WebHookSettings",
            "kind": "LinkedField",
            "name": "webhookSettings",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WebHookDeliveryEndpoint",
                "kind": "LinkedField",
                "name": "endpoints",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "webhookURL",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maskedSecretToken",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "OwnerWebhookDeliveriesConnection",
            "kind": "LinkedField",
            "name": "webhookDeliveries",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OwnerWebHookDeliveryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WebHookDelivery",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebHookDeliveryResponse",
                        "kind": "LinkedField",
                        "name": "response",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "webhookDeliveries(last:50)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OwnerInfo",
            "kind": "LinkedField",
            "name": "relatedOwners",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ec88577cf1d7efff7ac67e3f9d5eb4c4",
    "id": null,
    "metadata": {},
    "name": "OwnerSettingsRendererQuery",
    "operationKind": "query",
    "text": "query OwnerSettingsRendererQuery(\n  $platform: String!\n  $name: String!\n) {\n  ownerInfoByName(platform: $platform, name: $name) {\n    ...OwnerSettings_info\n    ...AppBreadcrumbs_info\n  }\n  viewer {\n    ...AppBreadcrumbs_viewer\n    id\n  }\n}\n\nfragment AccountSwitch_viewer on User {\n  relatedOwners {\n    platform\n    name\n  }\n}\n\nfragment AppBreadcrumbs_info on OwnerInfo {\n  platform\n  name\n}\n\nfragment AppBreadcrumbs_viewer on User {\n  ...AccountSwitch_viewer\n}\n\nfragment BillingSettingsButton_info on OwnerInfo {\n  billingSettings {\n    enabled\n    ...BillingSettingsDialog_billingSettings\n  }\n}\n\nfragment BillingSettingsDialog_billingSettings on BillingSettings {\n  platform\n  ownerUid\n  enabled\n  billingCreditsLimit\n  billingEmailAddress\n  invoiceTemplate\n}\n\nfragment ComputeCreditsBase_info on OwnerInfo {\n  ...BillingSettingsButton_info\n}\n\nfragment ComputeCreditsTransactionRow_transaction on OwnerTransaction {\n  timestamp\n  creditsAmount\n  task {\n    id\n    name\n    ...TaskCreatedChip_task\n    ...TaskDurationChip_task\n    ...TaskNameChip_task\n  }\n  repository {\n    ...RepositoryNameChip_repository\n    id\n  }\n}\n\nfragment ComputeCreditsTransactionsList_transactions on OwnerTransaction {\n  taskId\n  ...ComputeCreditsTransactionRow_transaction\n}\n\nfragment DeliveryRow_delivery on WebHookDelivery {\n  id\n  timestamp\n  response {\n    status\n  }\n}\n\nfragment MonthlyUsageChart_info on OwnerInfo {\n  monthlyComputeUsage {\n    date\n    usageDetails {\n      instancePlatform\n      instanceArchitecture\n      cpuSeconds\n      balanceInMicroCredits\n    }\n  }\n}\n\nfragment OwnerApiSettings_info on OwnerInfo {\n  platform\n  uid\n  apiToken {\n    maskedToken\n  }\n  ...OwnerScopedTokenDialog_ownerInfo\n}\n\nfragment OwnerComputeCredits_info on OwnerInfo {\n  uid\n  name\n  balanceInCredits\n  ...ComputeCreditsBase_info\n  transactions(last: 50) {\n    edges {\n      node {\n        ...ComputeCreditsTransactionsList_transactions\n      }\n    }\n  }\n}\n\nfragment OwnerPersistentWorkerPools_info on OwnerInfo {\n  uid\n  platform\n  persistentWorkerPools {\n    id\n    name\n    enabledForPublic\n  }\n}\n\nfragment OwnerScopedTokenDialog_ownerInfo on OwnerInfo {\n  platform\n  uid\n}\n\nfragment OwnerSecuredVariables_info on OwnerInfo {\n  platform\n  uid\n  name\n}\n\nfragment OwnerSettings_info on OwnerInfo {\n  platform\n  uid\n  name\n  viewerPermission\n  description {\n    message\n    actions {\n      title\n      link\n    }\n  }\n  ...OwnerComputeCredits_info\n  ...MonthlyUsageChart_info\n  ...OwnerApiSettings_info\n  ...OwnerSecuredVariables_info\n  ...OwnerPersistentWorkerPools_info\n  ...WebHookSettings_info\n}\n\nfragment RepositoryNameChip_repository on Repository {\n  owner\n  name\n}\n\nfragment TaskCreatedChip_task on Task {\n  creationTimestamp\n}\n\nfragment TaskDurationChip_task on Task {\n  id\n  status\n  creationTimestamp\n  scheduledTimestamp\n  executingTimestamp\n  durationInSeconds\n}\n\nfragment TaskNameChip_task on Task {\n  id\n  name\n}\n\nfragment WebHookSettings_info on OwnerInfo {\n  platform\n  uid\n  webhookSettings {\n    ownerUid\n    endpoints {\n      webhookURL\n      maskedSecretToken\n    }\n  }\n  webhookDeliveries(last: 50) {\n    edges {\n      node {\n        ...DeliveryRow_delivery\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "468969a432be1b8c9a331939b39e6934";

export default node;
